import * as types from './actionTypes'

export const getPaymentInfoGuestAction = itemId => ({
  type: types.GET_PAYMENT_INFO_GUEST,
  payload: itemId,
})

export const getPaymentInfoMemberAction = itemId => ({
  type: types.GET_PAYMENT_INFO_MEMBER,
  payload: itemId,
})
